import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';

// Gates a route behind sign-in. If the visitor is not authenticated we stash
// where they were headed and send them to /login; after login they land back.
function RequireAuth({ children, message = 'You need to be signed in to do that.' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const authed = isAuthenticated();

  useEffect(() => {
    if (!authed) {
      sessionStorage.setItem('postLoginRedirect', location.pathname);
      window.alert(message);
      navigate('/login', { replace: true });
    }
  }, [authed, location.pathname, navigate, message]);

  return authed ? children : null;
}

export default RequireAuth;
